import { render, staticRenderFns } from "./ReportCostsDialog.vue?vue&type=template&id=2808b48f&"
import script from "./ReportCostsDialog.vue?vue&type=script&lang=js&"
export * from "./ReportCostsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports